module.exports = __webpack_public_path__ + "static/media/Deer_main_t.ab719c3c.jpg";